import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const DocCsvOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" d="M15.412 2.012l5.61 5.572-.033 14.402h-1.983v.026h-14v-.083h-2V2.012h12.406zm-2.39 2H5.005v16h13.992l.02-10h-5.995v-6zm2 .43l-.001 3.57h3.595l-3.594-3.57z" />
  </SvgIcon>
);
